import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'commonTopic' })
class CommonTopic extends VuexModule {
  common_topic_unread_count: number = 0
  reloadUnread: boolean = false
  info: {
    avatar: string
    title: string
  } = { avatar: '', title: '' }

  @Mutation
  setNewCommonTopicCount(count: number) {
    this.common_topic_unread_count = count
  }

  @Action
  SET_NEW_COMMON_TOPIC_COUNT(count: number) {
    this.context.commit('setNewCommonTopicCount', count)
  }

  @Mutation
  setRealoadUnread(reaload: boolean) {
    this.reloadUnread = reaload
  }

  @Action
  SET_RELOAD_UNREAD(reaload: boolean) {
    this.context.commit('setRealoadUnread', reaload)
  }

  @Mutation
  setCommonTopicInfo({ avatar, title }: { avatar: string; title: string }) {
    this.info = { avatar, title }
  }

  @Action
  SET_COMMON_TOPIC_INFO({ avatar, title }: { avatar: string; title: string }) {
    this.context.commit('setCommonTopicInfo', { avatar, title })
  }
}

export default CommonTopic
